// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"220":"b68657b2","354":"d83f4afa","515":"2f350ec4","626":"d85c10fb","664":"33bb4dcb","705":"4154a77c","784":"eda1b913"}[chunkId] + ".chunk.js";
};